const DEV = "dev";
const QA = "qa";
const UAT = "uat";
const RC = "rc";
const RCDR = "rcdr";
const DR = "dr";

const GA_DEV_KEY = "UA-157017132-3";
const GA_QA_KEY = "UA-157017132-4";
const GA_UAT_KEY = "UA-157017132-5";
const GA_RC_KEY = "UA-157017132-6";
const GA_PRODUCTION_KEY = "UA-157017132-7";
const GA_RCDR_KEY = "UA-157017132-8";
const GA_DR_KEY = "UA-157017132-7";

const getGAKey = (): string => {
  const hostName = window.location.hostname;
  if (hostName.includes(DEV) || hostName.includes('localhost') || hostName.includes('127.0.0.1')) return GA_DEV_KEY;
  if (hostName.includes(QA)) return GA_QA_KEY;
  if (hostName.includes(UAT)) return GA_UAT_KEY;
  if (hostName.includes(RCDR)) return GA_RCDR_KEY;
  if (hostName.includes(RC)) return GA_RC_KEY;
  if (hostName.includes(DR)) return GA_DR_KEY;
  return GA_PRODUCTION_KEY;
};

// Google Analytics
export const GOOGLE_ANALYTICS_TRACKING_ID = getGAKey();
